import { Link } from 'react-router-dom'
import { SEO } from '@/components/seo'

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found | WealthSpace"
        description="The page you're looking for doesn't exist. Return to WealthSpace homepage."
        url="/404"
      />
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 text-center">
        <div className="max-w-[600px]">
          {/* Error Code */}
          <div
            className="font-serif text-accent-teal leading-none mb-4"
            style={{ fontSize: '120px', fontWeight: 700, opacity: 0.9 }}
          >
            404
          </div>

          {/* Error Title */}
          <h1
            className="font-serif text-brand-light mb-4"
            style={{ fontSize: '32px', fontWeight: 500 }}
          >
            Page not found
          </h1>

          {/* Error Message */}
          <p
            className="text-brand-muted leading-relaxed mb-8"
            style={{ fontSize: '18px' }}
          >
            Sorry, we couldn't find the page you're looking for. It may have been moved, deleted, or perhaps the URL was mistyped.
          </p>

          {/* Back to Homepage Button */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-br from-accent-teal to-accent-tealDark text-white font-semibold rounded-lg transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg"
            style={{ fontSize: '16px' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              className="w-[18px] h-[18px]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Back to Homepage
          </Link>

          {/* Helpful Links Section */}
          <div
            className="mt-12 pt-8"
            style={{ borderTop: '1px solid #e2e8f0' }}
          >
            <h3
              className="font-serif text-brand-muted mb-4"
              style={{ fontSize: '18px', fontWeight: 500, opacity: 0.6 }}
            >
              Perhaps you were looking for:
            </h3>
            <div className="flex gap-6 justify-center flex-wrap">
              <Link
                to="/product"
                className="text-accent-teal text-[15px] transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                Features
              </Link>
              <Link
                to="/pricing"
                className="text-accent-teal text-[15px] transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                Pricing
              </Link>
              <Link
                to="/about"
                className="text-accent-teal text-[15px] transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                About Us
              </Link>
              <Link
                to="/sign-up"
                className="text-accent-teal text-[15px] transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                Sign Up
              </Link>
              <Link
                to="/blog"
                className="text-accent-teal text-[15px] transition-opacity duration-200 hover:opacity-80 hover:underline"
              >
                Blog
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
